import React from 'react';
import PropTypes from 'prop-types';
import {useParams} from 'react-router-dom';
import data from '../lang/arsskyrsla-data.json';
import {Heading, Text, Link, HStack, useBreakpointValue} from '@chakra-ui/react';
import {Breadcrumbs} from '../components';

function BasePage({type}) {
    BasePage.propTypes = {
        type: PropTypes.string.isRequired,
    };
    const {id} = useParams();
    const isMobile = useBreakpointValue({base: true, md: false});
    let breadcrumbLabel;
    let title;
    let child = false;
    let breadcrumbParent;
    let description;
    let descriptionLink;
    if (type === 'seeMore') {
        const seeMorePage = data.versions[0].seeMorePages.find(
            item => item.id === parseInt(id)
        );
        breadcrumbLabel = seeMorePage.breadcrumbs.label;
        title = seeMorePage.title;
        description = seeMorePage.description;
        if (seeMorePage.breadcrumbs.parent) {
            child = true;
            breadcrumbParent = seeMorePage.breadcrumbs.parent;
        }
        descriptionLink = seeMorePage.descriptionLink;
    } else {
        const page = data.versions[0].pages.find(item => item.page === type);
        breadcrumbLabel = page.breadcrumbLabel;
        title = page.title;
        description = page.description;
        descriptionLink = page.descriptionLink;
    }

    return (
        <React.Fragment>
            <Breadcrumbs current={breadcrumbLabel} child={child} parent={breadcrumbParent}/>
            <Heading variant="heading2">
                {title}
            </Heading>
            <Text marginTop="32px" mb={isMobile ? "55px" : "0"} whiteSpace="pre-line" textStyle="customBodyMedium">{description}</Text>
            {descriptionLink &&
                <HStack spacing={2} mt="32px" align="center">
                    <Link href={descriptionLink.url} target="_blank" rel="noopener noreferrer" color="#00007C" className="linkTo">
                        {descriptionLink.label}
                    </Link>
                </HStack>}
        </React.Fragment>
    );
}

export default BasePage;